module.exports = __webpack_public_path__ + "img/domestic-1983-mao.80c80885.jpg";